<template>
  <div class="orderStatistics">
    <headerNotice routerName="订单统计"></headerNotice>
    <div v-loading="loading" class="content">
      <div class="header">
        <dateSelector @dateChange="getDataByTime" />
        <!-- <div class="export">
          <el-button type="text" style="color: #000;">
            统计说明
            <i class="el-icon-question"></i>
          </el-button>
          <el-button type="text" style="color: #000;">
            <i class="el-icon-printer"></i>
            导出
          </el-button>
        </div>-->
      </div>
      <h1 class="title">订货单</h1>
      <el-row style="padding: 10px 0;">
        <el-col>
          <el-select @change="getDataByMan" v-model="salesmanId">
            <el-option label="全部业务员" :value="0"></el-option>
            <el-option
              v-for="item in memberList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col>
        <span class="cont_left"> 订单号</span>
          <el-input v-model="searchfrom.orderNo" placeholder="请输入订单编号" clearable size="small"></el-input>
        </el-col>
        <el-col>
          <span class="cont_left"> 支付方式</span>
        
          <el-select v-model="searchfrom.payType" clearable placeholder="请选择支付方式">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="微信" :value="1"></el-option>
            <el-option label="余额" :value="2"></el-option>
            <el-option label="慧呗" :value="3"></el-option>
          </el-select>
        </el-col>
        <el-col>
        <span class="cont_left">  所属仓库</span>
          <el-select v-model="searchfrom.warehouse" placeholder="请选择所属仓库">
            <el-option label="请选择所属仓库" :value="0"></el-option>
            <el-option
              v-for="item in houseList"
              :key="item.houseID"
              :label="item.houseName"
              :value="item.houseID"
            ></el-option>
          </el-select>
        </el-col>
        <el-col>
        <span class="cont_left">地区</span>
          <el-cascader
            ref="regin"
            v-loading="regionLoading"
            placeholder="地址搜索"
            :options="AllAreaOptions"
            :props="cascaderProps"
            @change="AreaHandleChange"
            change-on-select
          ></el-cascader>
        </el-col>
        <el-col>
        <span class="cont_lft"> 客户</span>
          <el-input v-model="searchfrom.customer" placeholder="请输入客户" clearable size="small"></el-input>
        </el-col>
        <el-col>
             <span class="cont_lft"> 商品名称</span>
          
          <el-input v-model="searchfrom.itemName" placeholder="请输入商品名称" clearable size="small"></el-input>
        </el-col>
        <el-col>
         <span class="cont_lft"> 支付状态</span>
          <el-select v-model="searchfrom.payStatus" clearable placeholder="请选择支付状态">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="已支付" :value="1"></el-option>
            <el-option label="未支付" :value="2"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-button type="primary" @click="searchclick">
        <i class="el-icon-search"></i> 查询
      </el-button>
      <sum-list :list="dataSum" />
      <div id="myChart" style="width: 100%;height:400px; margin-top: 20px;"></div>

      <h1 class="title">详细数据</h1>

      <el-table
        :data="orderData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column align="center" prop="date" label="日期"></el-table-column>
        <el-table-column align="center" prop="orderCount" label="订货单数" sortable></el-table-column>
        <el-table-column align="center" prop="customerCount" label="订货客户" sortable></el-table-column>
        <el-table-column align="center" prop="amount" label="订货金额(￥)" sortable></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
import dateSelector from "./dateSelector.vue";
import sumList from "./sumList.vue";
import echarts from "echarts";
export default {
  components: {
    headerNotice,
    sumList,
    dateSelector
  },
  props: {},
  data() {
    return {
      loading: false,
      duration: [],
      orderData: [],
      chartData: {
        x_date: [],
        yl_amount: [],
        yr_orderCount: []
      },
      dataSum: [],
      memberList: [],
      salesmanId: 0,

      searchfrom: {}, //查询条件
      houseList: [],

      AllAreaOptions: [], //客户地址
      regionLoading: true,
      cascaderProps: {
        children: "children",
        label: "name",
        value: "code"
      }
    };
  },
  watch: {
    // duration(val) {
    //   console.log(val)
    // }
  },
  computed: {},
  created() {
    this.getMemberList({
      MaxResultCount: 9999,
      SkipCount: 0
    });
    this.getSelectData();
    this.getAllRegin();
  },
  mounted() {},
  methods: {
    //获取下拉数据
    getSelectData() {
      let self = this;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/Warehouse/GetAllWareHouse",
        success(res) {
          self.houseList = res;
        },
        fail(res) {}
      });
    },
    //获取所有省市区数据
    getAllRegin() {
      let self = this;
      self.regionLoading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/Province/GetAllRegion",
        success(res) {
          self.reginData = res;
          let allRegin = {
            name: "全部",
            code: null,
            children: []
          };

          self.AllAreaOptions = [allRegin, ...res];
          self.regionLoading = false;
        },
        fail(res) {
          self.regionLoading = false;
        }
      });
    },
    //下拉选择省市事件
    AreaHandleChange(value) {
      let self = this;
      self.searchfrom.areaCode = "";
      if (value.length == 3) {
        self.searchfrom.areaCode = value[2];
      }
      //let params = self.searchfrom;
      //self.getDatas(params);
    },
    // 员工列表
    getMemberList(params) {
      let self = this;
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminSalesman/GetList",
        params: params,
        success(res) {
          // console.log(res);
          self.memberList = self.dealMemberList(res);
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    // 提取员工列表
    dealMemberList(list) {
      var temp = [];
      list.items.forEach(item => {
        temp.push({
          label: item.realName,
          value: item.userId
        });
      });
      // console.log(temp)
      return temp;
    },
    // 更改时间重新发请求
    getDataByTime(date) {
      console.log(date[0])
      console.log(date[1])
      this.duration = date;
      this.searchfrom.StartTime = date[0];
      this.searchfrom.EndTime = date[1];
      this.searchfrom.SalesmanId = this.salesmanId;
      this.searchfrom.TimeSortType = 1;
      this.getOrderData(this.searchfrom);
    },
    // 更改员工发送请求
    getDataByMan() {
      this.searchfrom.StartTime = this.duration[0];
      this.searchfrom.EndTime = this.duration[1];
      this.searchfrom.SalesmanId = this.salesmanId;
      this.searchfrom.TimeSortType = 1;
      this.getOrderData(this.searchfrom);
    },
    searchclick(){
      this.getOrderData(this.searchfrom);
    },
    // 订单数据
    getOrderData(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminStatistics/GetOrderList",
        params: params,
        success(res) {
          self.orderData = self.initData(res.items);
          self.chartData = self.initChartData(self.orderData);
          self.dataSum = self.getDataSum(res);
          self.initChart();
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    // 订单数据提取
    initData(data) {
      var arr = [];
      data.forEach(item => {
        arr.push({
          date: this.getDateStr(item.Date),
          amount: item.StatisticsInfo.Amount,
          customerCount: item.StatisticsInfo.CustomerCount,
          orderCount: item.StatisticsInfo.OrderCount
        });
      });
      return arr;
    },
    getDateStr(str) {
      return str.match(/\d+-\d+-\d+/g)[0];
    },
    // 总数据
    getDataSum(data) {
      return [
        { title: "订货单数", value: data.orderCount },
        { title: "订货客户", value: data.customerCount },
        { title: "订货金额", value: data.amount }
      ];
    },
    // 图表数据处理
    initChartData(data) {
      var temp = {
        x_date: [],
        yl_amount: [],
        yr_orderCount: []
      };
      data.forEach(item => {
        temp.yl_amount.push(item.amount);
        temp.yr_orderCount.push(item.orderCount);
        temp.x_date.push(item.date);
      });
      // console.log(temp);
      return temp;
    },
    // 初始化图表
    initChart() {
      var myChart = echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        legend: {
          data: ["订单金额", "订单笔数"]
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56"
            }
          }
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: { onZero: false },
            data: this.chartData.x_date
          }
        ],
        yAxis: [
          {
            name: "订单金额/元",
            type: "value",
            max: Math.max.apply({}, this.chartData.yl_amount)
          },
          {
            name: "单数",
            max: Math.max.apply({}, this.chartData.yr_orderCount),
            type: "value"
          }
        ],
        series: [
          {
            name: "订单金额",
            type: "line",
            animation: false,
            data: this.chartData.yl_amount
          },
          {
            name: "订单笔数",
            type: "line",
            yAxisIndex: 1,
            animation: false,
            data: this.chartData.yr_orderCount
          }
        ]
      });
    }
  }
};
</script>
<style >
.orderStatistics .content .cont_left{
  width: 100px;
}
.orderStatistics .content  .el-col-24 {
  display: flex;
    width: 100%;
    align-items: center;
    margin-top: 20px;
}
.orderStatistics .content .el-input{
  width: 80%
}
</style>
<style lang="scss" scoped>
.orderStatistics {
  .content {
    padding: 0 50px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
  }
  .title {
    padding-left: 20px;
    background: #f3f3f3;
    line-height: 50px;
  }
  #myChart {
    margin-top: 10px;
  }
   .cont_lft{
    width: 100px;
  }
}
</style>